import React from 'react'

import ComboBox from '@react/react-spectrum/ComboBox'
import { LOCALES } from 'config/constants'

export default function LocalePicker({ value, disabled, onChange }) {
  return <ComboBox options={LOCALES} value={value} onChange={onChange} onSelect={onChange} disabled={disabled} />
}
